"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { RiAddLine, RiLoader2Fill, RiMore2Fill } from "react-icons/ri";
import Button from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown";
import { cx } from "@/lib/tailwind-utils";
interface MessageActionsMenuProps {
  align: "start" | "end";
  isDrafting: boolean;
  onCreateTask: () => void;
}
export function MessageActionsMenu(t0) {
  const $ = _c(20);
  const {
    align,
    isDrafting,
    onCreateTask
  } = t0;
  const [open, setOpen] = useState(false);
  const forceVisible = open || isDrafting;
  const t1 = forceVisible && "opacity-100";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("opacity-0 transition-opacity group-hover/msg:opacity-100 focus-within:opacity-100", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isDrafting) {
    t3 = isDrafting ? <RiLoader2Fill className="size-4 animate-spin" /> : <RiMore2Fill className="size-4" />;
    $[2] = isDrafting;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isDrafting || $[5] !== t3) {
    t4 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" size="icon-sm" aria-label="Message actions" disabled={isDrafting}>{t3}</Button></DropdownMenuTrigger>;
    $[4] = isDrafting;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RiAddLine />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onCreateTask) {
    t6 = <DropdownMenuItem icon={t5} onClick={onCreateTask}>Create task</DropdownMenuItem>;
    $[8] = onCreateTask;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== align || $[11] !== t6) {
    t7 = <DropdownMenuContent align={align}>{t6}</DropdownMenuContent>;
    $[10] = align;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== open || $[14] !== t4 || $[15] !== t7) {
    t8 = <DropdownMenu open={open} onOpenChange={setOpen}>{t4}{t7}</DropdownMenu>;
    $[13] = open;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8) {
    t9 = <div className={t2}>{t8}</div>;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}